import 'intersection-observer';
import { addSize, setBaseUrls } from '@/core/responsive/image/responsive-image.service';
import serverContextStore from '@/shared/content/server-context.store';

setBaseUrls({
    cdnProductImages: serverContextStore.state.cdnProductImages,
    cdnAssetImages: serverContextStore.state.cdnAssetImages,
});

addSize(320);
addSize(640);
addSize(1024);
addSize(1600);
